import { CommonKeys } from "../../../common/enums";
import { STAMM_META_TYPE } from "../../interfaces/stammelements/StammElementMeta";

export const FormularGroupStammStammElementMetaSchema = {
    $id: "FormularGroupStammStammElementMetaSchema",
    title: "FormularGroupStammStammElementMeta Schema",
    type: "object",
    allOf: [
        { $ref: "FormularGroupStammStammElementBaseSchema" },
        {
            type: "object",
            properties: {
                [CommonKeys.Type]: { const: STAMM_META_TYPE },
                Typ: { type: "number", nullable: true },
                ManualInputType: { type: "number", nullable: true }
            }
        }
    ],
};